import dayjs from "dayjs";
import { parsePhoneNumberFromString } from "libphonenumber-js";

const StartSellingHomeThanks = ({ userName, phoneNumber, dateTime }) => {
  const formattedDateAndTime = dateTime
    ? dayjs(dateTime).subtract(1, "day").format("MMMM D, YYYY [At] hh:mm A")
    : null;

  const parsedPhone = phoneNumber
    ? parsePhoneNumberFromString(phoneNumber)
    : null;

  const FormattedPhone = parsedPhone
    ? `+${parsedPhone.countryCallingCode} (${parsedPhone.nationalNumber.slice(
        0,
        3
      )}) ${parsedPhone.nationalNumber.slice(
        3,
        6
      )}-${parsedPhone.nationalNumber.slice(6)}`
    : "";

  return (
    <div className="thanks_container">
      <h6 className="thanks_heading">{`Thank You, ${userName}! — You’re on the Right Track!`}</h6>
      <p className="thanks_text mt-3">
        It’s people like <strong>you</strong> who take control of their home sale!
      </p>

      <p className="thanks_text">
        <strong>
          {`👉 We will contact you at ${FormattedPhone} ${
            formattedDateAndTime && ` On ${formattedDateAndTime}`
          }`}
        </strong>{" "}
        to connect you with the right agent and start preparing your home for a
        successful sale.
      </p>
      <p className="thanks_text">
        Thank you again for your trust and support — we’re excited to help you
      </p>

      <p className="thanks_text">
        <strong>
          <u>Know Someone Buying or Selling a home?</u>
        </strong>
      </p>

      <p className="thanks_text">
        <strong>Get Rewarded!</strong>
      </p>

      <p className="thanks_text">
        We offer a <strong>Leads Reward Program</strong> for
        clients who refer <strong>serious buyers and sellers.</strong> It’s our
        way of showing appreciation for your trust — and for{" "}
        <strong>
          spreading the word.
        </strong>{" "}
      </p>
      <p className="thanks_text">
        Ask us how you can start earning rewards for your referrals today!
      </p>
    </div>
  );
};

export default StartSellingHomeThanks;
